import { render, staticRenderFns } from "./FloatingWobble.vue?vue&type=template&id=1a221d2f&scoped=true&"
import script from "./FloatingWobble.vue?vue&type=script&lang=ts&"
export * from "./FloatingWobble.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingWobble.vue?vue&type=style&index=0&id=1a221d2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a221d2f",
  null
  
)

export default component.exports